export enum DepositPaymentStatusEnum {
  Draft = 'Draft',
  Processing = 'Processing',
  Rejected = 'Rejected',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Returned = 'Returned',
}
